import { Box, Divider, Paper, Stack, Typography } from "@mui/material";
import React from "react";
import { APP_ICONS } from "../../assets";
import appcolors from "../../constants/Colors";

function Template({ headProps, children, primaryHeading, secondaryHeading }) {
  return (
    <Paper sx={{ borderRadius: 1 }}>
      <Stack
        p={2}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Stack gap={2} direction={"row"} alignItems={"center"}>
          <img
            src={APP_ICONS.fourArrowIcon}
            alt={"card-icon"}
            width={35}
            height={35}
          />
          <Box>
            <Typography
              variant={"body1"}
              fontWeight={600}
              lineHeight={"normal"}
            >
              {primaryHeading}
            </Typography>
            <Typography variant={"body2"} color={"custom.crayolaGrey"}>
              {secondaryHeading}
            </Typography>
          </Box>
        </Stack>
        {headProps && (
          <Box mt={2} width="100%">
            {headProps}
          </Box>
        )}
      </Stack>
      <Divider />
      <Box
        p={"8px 16px"}
        sx={{
          height: "400px",
          overflow: "auto",
        }}
      >
        {children}
      </Box>
    </Paper>
  );
}

export default Template;
